/** Firestore path: `counters/lead_numbers` with `{ next: number }`. */
export const LEAD_NUMBER_COUNTER_COLLECTION = "counters";
export const LEAD_NUMBER_COUNTER_DOC_ID = "lead_numbers";

const LEAD_NUMBER_PATTERN = /^L(\d{2})-(\d{5})$/;

/** Human-readable lead id, e.g. `L26-00042` (year suffix + global sequence). */
export const formatLeadNumber = (sequence: number, createdAt: Date): string => {
  const yearSuffix = (createdAt.getFullYear() % 100).toString().padStart(2, "0");
  const paddedSequence = Math.max(1, Math.floor(sequence))
    .toString()
    .padStart(5, "0");
  return `L${yearSuffix}-${paddedSequence}`;
};

/** Parses the trailing sequence from a lead number, or null if invalid. */
export const parseLeadNumberSequence = (leadNumber: string | null | undefined): number | null => {
  const trimmed = leadNumber?.trim();
  if (!trimmed) return null;
  const match = trimmed.match(LEAD_NUMBER_PATTERN);
  if (!match) return null;
  const sequence = Number(match[2]);
  return Number.isFinite(sequence) ? sequence : null;
};
